module.exports = __webpack_public_path__ + "img/4979849.jpg";